/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
( ( FUNCTIONS ) => {
	const a = 'is-active';
	const v = 'is-visible';

	const topSwiper = () => {
		const swiper01 = new Swiper( ".top-swiper01", {
			slidesPerView: 2,
			spaceBetween: 50,
			loop: true,
			speed: 2000,
			autoplay: {
				delay: 3000,
			},
			pagination: {
				el: ".swiper-pagination"
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			},
			breakpoints: {
				1025: {
					spaceBetween: 100,
				}
			}
		} );
		const tag = () => {
			const tag = document.querySelectorAll('.cf_n_tags')
			for (let i = 0; i < tag.length; i++) {
				if (!tag[i].children.length) {
					tag[i].classList.add('di_none');
				}
			}
		};
		tag();
		const swiper02 = new Swiper( ".top-swiper02", {
			slidesPerView: 2,
			spaceBetween: 50,
			loop: true,
			speed: 2000,
			autoplay: {
				delay: 3000,
			},
			pagination: {
				el: ".swiper-pagination"
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			},
			breakpoints: {
				767: {
					spaceBetween: 60,
				},
				1025: {
					slidesPerView: 3,
					spaceBetween: 60,
				}
			}
		} );
	};

	topSwiper();


} )( window.FUNCTIONS );
